"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocOffPlasticNegative = function SvgBDocOffPlasticNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M48.63 37.363H28.702a2.107 2.107 0 01-2.108-2.108v-11a2.107 2.107 0 114.215 0v8.893h15.714V17.435H28.702a2.107 2.107 0 010-4.215H48.63c1.164 0 2.107.943 2.107 2.107v19.928a2.107 2.107 0 01-2.107 2.108zM48.616 57.382H28.702a2.107 2.107 0 010-4.214h19.914a2.107 2.107 0 110 4.214zM48.616 67.329H28.702a2.107 2.107 0 010-4.215h19.914a2.107 2.107 0 110 4.215zM22.057 83.822h-9.954a2.107 2.107 0 01-2.107-2.107V51.882a2.107 2.107 0 014.214 0v27.725h7.847a2.107 2.107 0 010 4.215z"
  }), (0, _core.jsx)("path", {
    d: "M65.236 83.822h-28.71a2.107 2.107 0 110-4.215h26.602V51.882a2.107 2.107 0 014.215 0v29.833a2.107 2.107 0 01-2.107 2.107zM65.236 42.434a2.107 2.107 0 01-2.108-2.107V4.215H14.21v36.112a2.107 2.107 0 11-4.214 0V2.107C9.996.943 10.939 0 12.103 0h53.133c1.163 0 2.107.943 2.107 2.107v38.22a2.107 2.107 0 01-2.107 2.107z"
  }), (0, _core.jsx)("path", {
    d: "M70.455 143.614H6.814A6.828 6.828 0 010 136.8v-11.878a2.107 2.107 0 014.215 0V136.8a2.599 2.599 0 002.599 2.599h63.64a2.599 2.599 0 002.6-2.599V46.558a2.599 2.599 0 00-2.6-2.592H6.815a2.599 2.599 0 00-2.6 2.592v65.08a2.107 2.107 0 01-4.214 0v-65.08a6.82 6.82 0 016.814-6.807h63.64a6.82 6.82 0 016.814 6.807V136.8a6.828 6.828 0 01-6.813 6.814z"
  }), (0, _core.jsx)("path", {
    d: "M18.734 100.449a2.107 2.107 0 01-1.49-3.597l19.901-19.9a2.108 2.108 0 012.985 2.979L20.223 99.817c-.392.4-.928.628-1.489.632zM32.06 120.405a2.107 2.107 0 01-1.49-3.596l16.444-16.452a2.108 2.108 0 012.979 2.986l-16.445 16.444c-.394.395-.93.618-1.489.618zM38.634 27.395a2.107 2.107 0 01-2.107-2.107 2.107 2.107 0 01.611-1.49 2.185 2.185 0 012.985 0 2.107 2.107 0 01-1.489 3.597zM108.344 32.396a2.107 2.107 0 01-1.489-.618L96.712 21.635 86.569 31.778A2.107 2.107 0 0183.59 28.8l11.633-11.632a2.17 2.17 0 012.978 0L109.833 28.8a2.107 2.107 0 01-1.489 3.596z"
  }), (0, _core.jsx)("path", {
    d: "M96.712 50.695a2.107 2.107 0 01-2.108-2.107V18.692a2.107 2.107 0 014.215 0v29.896a2.107 2.107 0 01-2.107 2.107z"
  })));
};

var _default = SvgBDocOffPlasticNegative;
exports["default"] = _default;